import React, { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import AppContext from '../../../context/AppContext';
import Checkbox from '../../../shared/Checkbox';
import AddItem from '../../../shared/AddItem';
import DragNDropList from '../../../shared/DragNDropList';
import Item from '../../../shared/Certifications/Item';

const Certifications = ({ data, onChange }) => {
  const context = useContext(AppContext);
  const { dispatch } = context;
  const { t } = useTranslation('leftSidebar');

  const isAllDisabled = data.certifications.items.every((item) => !item.enable);
  const isAllEnabled = data.certifications.items.every((item) => item.enable);

  useEffect(() => {
    if (isAllDisabled) {
      onChange('data.certifications.enable', false);
    }
    if (isAllEnabled && !data.certifications.enable) {
      onChange('data.certifications.enable', true);
    }
    // eslint-disable-next-line
  }, [isAllDisabled, isAllEnabled]);

  return (
    <>
      <div className="mb23 flex justify-between items-center">
        <div className="title_tab col-span-5 mt-4">{t('certifications.title.label')}</div>
        <div className="col-span-1">
          <Checkbox
            checked={data.certifications.enable}
            onChange={(v) => onChange('data.certifications.enable', v)}
            preLabel="Show on CV"
          />
        </div>
      </div>
      <DragNDropList data={data} dispatch={dispatch} onChange={onChange} type="certifications">
        {data.certifications.items.map((x, index) => (
          <Item
            item={x}
            key={x.id}
            index={index}
            onChange={onChange}
            dispatch={dispatch}
            first={index === 0}
            last={index === data.certifications.items.length - 1}
          />
        ))}
      </DragNDropList>
      <AddItem
        heading="Certificate"
        dispatch={dispatch}
        existingItems={data.certifications.items}
      />
    </>
  );
};

export default Certifications;
